import {getFactionSkinConfig} from '../../configs/factions/skins/allFactionSkins';

/**
 * Рейтинг обличия — skinRank из его конфига (по нему рисуются шевроны, см.
 * SkinRankMark). Рейтинг есть только у обычных обличий: у базового вида
 * фракции (`humans_default`), у рейтинговых образов лиг (`humans_gold`), у
 * образов отрядов и у неизвестных id конфига нет — и рейтинга тоже.
 *
 * С factionId обличие другой фракции рейтинга не дает: так выбранный образ
 * из раскладки, устаревший или чужой, не получит шевронов поверх картинки
 * базового вида — та же сверка фракции, что и в getFactionSkinDisplayProps.
 *
 * @param {string} [skinId] - идентификатор обличия
 * @param {string} [factionId] - фракция, чье обличие ожидается
 * @returns {number|null} рейтинг обличия (1–6) или null
 */
export const getFactionSkinRank = (skinId, factionId) => {
  if (!skinId) {
    return null;
  }

  const skinConfig = getFactionSkinConfig(skinId);
  if (!skinConfig || (factionId && skinConfig.factionId !== factionId)) {
    return null;
  }

  return skinConfig.skinRank || null;
};
